module.exports = __webpack_public_path__ + "img/flag.e82605c7.svg";